import {createSelector} from 'reselect';
import {partnerIntegrations} from '../../constants';

export const selectIsLoggedIn = state => state.getIn(['account', 'isLoggedIn']);

export const selectShouldFetchAccount = state =>
    !state.getIn(['account', 'hasAttemptedToSetAccount']);

export function selectAccountInfo(state) {
    return state.getIn(['account', 'account']);
}

export const selectAccountId = state => state.getIn(['account', 'account', 'id']);

export const selectAccountDisplayName = state => state.getIn(['account', 'account', 'displayName']);

export const selectUplayToken = state => state.getIn(['account', 'uplayToken']);

export const selectAccountExternalAuths = state =>
    state.getIn(['account', 'account', 'externalAuths']);

export const selectAccountAssociatedOrganizations = state =>
    state.getIn(['account', 'account', 'associatedOrganizations']);

export const selectIsUplayLinkRunning = state => state.getIn(['account', 'uplayLinkInProgress']);

export const selectAccountIsDeveloper = createSelector(
    selectAccountAssociatedOrganizations,
    orgs => {
        if (!orgs) return undefined;
        const developerOrg = orgs.find(org => org.get('isDeveloper'));
        return developerOrg && developerOrg.get('isDeveloper');
    }
);

export const selectIsUplayLinked = createSelector(
    selectAccountExternalAuths,
    externalAuths => {
        if (!externalAuths) return false;
        return !!externalAuths.find(
            auth => auth.get('type') === partnerIntegrations.partnerTypes.UBISOFT
        );
    }
);

export const selectUplayAccountId = createSelector(
    selectAccountExternalAuths,
    externalAuths => {
        if (!externalAuths) return undefined;
        const ubisoftExternalAuth = externalAuths.find(
            auth => auth.get('type') === partnerIntegrations.partnerTypes.UBISOFT
        );
        return ubisoftExternalAuth && ubisoftExternalAuth.get('externalAuthId');
    }
);

export const selectIs2FAEnabled = state => state.getIn(['account', 'account', 'tfaEnabled']);

export default {
    selectAccountId,
    selectAccountInfo,
    selectAccountIsDeveloper,
    selectIs2FAEnabled,
    selectIsLoggedIn,
    selectIsUplayLinked,
    selectUplayAccountId,
    selectUplayToken
};
